// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_activeLink__DJ4c4 .styles_wrapper__OEyEI {
  width: 100%;
  background: linear-gradient(0deg, rgba(255, 19, 109, 0.1), rgba(255, 19, 109, 0.1)), #080808;
  border-radius: 16px;
}
.styles_activeLink__DJ4c4 .styles_label__jkpZb {
  color: #ffffff;
}
.styles_activeLink__DJ4c4 path {
  stroke: #ff136d;
}

.styles_link__nf3ue:nth-child(4) .styles_icon__uNpfL svg path,
.styles_link__nf3ue:last-child .styles_icon__uNpfL svg path {
  fill: #b6b6b6;
}

.styles_link__nf3ue:nth-child(4).styles_activeLink__DJ4c4 .styles_icon__uNpfL svg path {
  fill: #ff136d;
}

.styles_wrapper__OEyEI {
  padding: 16px 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.styles_label__jkpZb {
  font-weight: 300;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: #b6b6b6;
}`, "",{"version":3,"sources":["webpack://./src/components/pageWrapper/pageHeaderMobile/burgerMenu/navBlock/navItem/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAGE;EACE,WAAA;EACA,4FAAA;EACA,mBAAA;AAFJ;AAKE;EACE,cCVI;ADOR;AAME;EACE,eCJG;ADAP;;AAUE;;EACE,aCMO;ADZX;;AAWE;EACE,aCjBG;ADSP;;AAYA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AATF;;AAYA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,cCjBS;ADQX","sourcesContent":["@import './src/assets/styles/variables/colors';\n\n.activeLink {\n  .wrapper {\n    width: 100%;\n    background: linear-gradient(0deg, $pink-10, $pink-10), $black-nav-bg;\n    border-radius: 16px;\n  }\n\n  .label {\n    color: $white;\n  }\n\n  path {\n    stroke: $pink;\n  }\n}\n\n.link:nth-child(4),\n.link:last-child {\n  .icon svg path {\n    fill: $grey-nav;\n  }\n}\n\n.link:nth-child(4).activeLink {\n  .icon svg path {\n    fill: $pink;\n  }\n}\n\n.wrapper {\n  padding: 16px 24px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.label {\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $grey-nav;\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activeLink": `styles_activeLink__DJ4c4`,
	"wrapper": `styles_wrapper__OEyEI`,
	"label": `styles_label__jkpZb`,
	"link": `styles_link__nf3ue`,
	"icon": `styles_icon__uNpfL`
};
export default ___CSS_LOADER_EXPORT___;
